import { DARK } from '@core/constants/theme';

export const createStyles = (theme: any) => {
  const { palette } = theme;
  const isDarkMode = palette?.mode === DARK;
  // Text color for each theme
  const textColor = isDarkMode ? palette.primary.light : palette.primary.dark;

  return {
    button: {
      color: textColor,
      borderRadius: '0.25rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      fontSize: '1rem',
      fontWeight: 500,
      '&:hover': {
        backgroundColor: palette.action.hover,
        color: textColor,
      },
    },
  };
};
